import { StandardPage } from 'src/components/UI/StandardPage/StandardPage';

export * from './useNoClientDescription';

export default StandardPage;
